import { useEffect } from "react";

const OG = "/assets/11-social-share-cover.webp";

export function PageMeta({ title, fullTitle, description, image }) {
  useEffect(() => {
    const full = fullTitle || (title ? `${title} · DBRF` : "DBRF | Scientific and Engineering Teams for Difficult Problems");
    document.title = full;
    const set = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [a, v] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(a, v.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    const desc =
      description ||
      "Digital Brain Research Foundation assembles interdisciplinary scientific and engineering expertise around complex corporate and institutional challenges.";
    set('meta[name="description"]', "content", desc);
    set('meta[property="og:title"]', "content", full);
    set('meta[property="og:description"]', "content", desc);
    set('meta[property="og:image"]', "content", image || OG);
    set('meta[property="og:type"]', "content", "website");
    set('meta[name="twitter:card"]', "content", "summary_large_image");
    set('meta[name="twitter:title"]', "content", full);
    set('meta[name="twitter:description"]', "content", desc);
    set('meta[name="twitter:image"]', "content", image || OG);

    // Canonical URL
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.origin + window.location.pathname);
  }, [title, fullTitle, description, image]);
  return null;
}
